'use client';
'use strict';

var react = require('react');

const VELOCITY_THRESHOLD = 1.0;
const CLOSE_HEIGHT_RATIO = 0.5;
const useBottomModalContainer = ({ onClose })=>{
    const containerRef = react.useRef(null);
    const [isDragging, setIsDragging] = react.useState(false);
    const [startY, setStartY] = react.useState(0);
    const [currentTranslate, setCurrentTranslate] = react.useState(0);
    const lastMoveTime = react.useRef(0);
    const lastMovePosition = react.useRef(0);
    const handleStart = (clientY)=>{
        setIsDragging(true);
        setStartY(clientY);
        lastMoveTime.current = Date.now();
        lastMovePosition.current = clientY;
    };
    const handleMove = (currentY)=>{
        var _a;
        if (!isDragging) return;
        const diff = currentY - startY;
        if (diff < 0) return;
        const containerHeight = ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
        const maxHeight = containerHeight * CLOSE_HEIGHT_RATIO;
        const currentTime = Date.now();
        const timeDiff = currentTime - lastMoveTime.current;
        const posDiff = currentY - lastMovePosition.current;
        const velocity = Math.abs(posDiff / timeDiff);
        if (velocity > VELOCITY_THRESHOLD) {
            onClose();
            setIsDragging(false);
            return;
        }
        const currentHeight = Math.min(diff, maxHeight);
        setCurrentTranslate(currentHeight);
        if (currentHeight >= maxHeight) {
            onClose();
            setIsDragging(false);
            return;
        }
        lastMoveTime.current = currentTime;
        lastMovePosition.current = currentY;
    };
    const handleTouchStart = (e)=>{
        e.preventDefault();
        handleStart(e.touches[0].clientY);
    };
    const handleTouchMove = (e)=>{
        e.preventDefault();
        handleMove(e.touches[0].clientY);
    };
    const handleTouchEnd = ()=>{
        if (!isDragging) return;
        setIsDragging(false);
        setCurrentTranslate(0);
    };
    react.useEffect(()=>{
        const header = document.getElementById('bottom-modal-header');
        if (!header) return;
        header.addEventListener('touchstart', handleTouchStart, {
            passive: false
        });
        header.addEventListener('touchmove', handleTouchMove, {
            passive: false
        });
        header.addEventListener('touchend', handleTouchEnd);
        return ()=>{
            header.removeEventListener('touchstart', handleTouchStart);
            header.removeEventListener('touchmove', handleTouchMove);
            header.removeEventListener('touchend', handleTouchEnd);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDragging,
        startY
    ]);
    return {
        containerRef,
        isDragging,
        currentTranslate
    };
};

module.exports = useBottomModalContainer;
